export const SET_MAIN_BRANDS = 'mainBrands/SET_MAIN_BRANDS';
export const CLEAR_MAIN_BRANDS = 'mainBrands/CLEAR_MAIN_BRANDS'; 